import { useFormikContext } from 'formik';
import moment from 'moment';
import { useEffect } from 'react';

interface FormikAutoSubmitProps {
  /** Valores ya aplicados: mientras `values` sea igual a estos no se envía nada. */
  initialValues: unknown;
  delay?: number;
}

/**
 * Envía el formulario de Formik automáticamente (con debounce) cuando sus
 * valores cambian, sin necesidad de un botón de "Aplicar".
 * No envía si el formulario es inválido o si hay una fecha incompleta.
 */
const FormikAutoSubmit = ({
  initialValues,
  delay = 500
}: FormikAutoSubmitProps) => {
  const { values, isValid, submitForm } =
    useFormikContext<Record<string, unknown>>();
  const valuesJson = JSON.stringify(values);
  const initialJson = JSON.stringify(initialValues);

  useEffect(() => {
    if (valuesJson === initialJson || !isValid) return;
    const hasInvalidDate = Object.values(values).some(
      (value) => moment.isMoment(value) && !value.isValid()
    );
    if (hasInvalidDate) return;

    const timeout = setTimeout(() => {
      submitForm();
    }, delay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesJson, initialJson, isValid]);

  return null;
};

export default FormikAutoSubmit;
